import { makeAutoObservable } from "mobx";
import { pagingPatientRank } from "app/services/PatientRank";

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { checkSearchObject } from "app/common/LocalFunction";
import { PageResponse } from "app/common/Model/Shared";
import { searchPriceReport, exportExcelPriceReport } from "app/services/ReportService";

export default class ReportPriceItemStore {
  searchReportPriceItem = {
    ...new SearchObject(),
    isUse: true,
    type: 0,
    groupIds: [],
    reportGroupIds: [],
    typePriceIds: [],
    minPrice: null,
    maxPrice: null,
  };
  currentTab = 0;
  pageReportPriceItem = new PageResponse();

  constructor() {
    makeAutoObservable(this);
  }

  getReportPriceItem = async () => {
    const searchObject = {
      ...this.searchReportPriceItem,
      groupIds: this.searchReportPriceItem.groupIds?.map((item) => item?.id || item) || [],
      reportGroupIds: this.searchReportPriceItem.reportGroupIds?.map((item) => item?.id || item) || [],
      typePriceIds: this.searchReportPriceItem.typePriceIds?.map((item) => item?.id || item) || [],
    };
    return await searchPriceReport(searchObject)
      .then(({ data }) => {
        this.pageReportPriceItem = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu báo cáo có lỗi");
      });
  };

  handleExportExcelPriceItem = async () => {
    const searchObject = {
      ...this.searchReportPriceItem,
      groupIds: this.searchReportPriceItem.groupIds?.map((item) => item?.id || item) || [],
      reportGroupIds: this.searchReportPriceItem.reportGroupIds?.map((item) => item?.id || item) || [],
      typePriceIds: this.searchReportPriceItem.typePriceIds?.map((item) => item?.id || item) || [],
    };
    try {
      const response = await exportExcelPriceReport(searchObject);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BAO_CAO_BANG_GIA.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
      toast.error("Có lỗi xảy ra khi xuất Excel");
    }
  };
  changeTab = (tab) => {
    this.currentTab = tab;
  };

  handleChangeFormSearch = (searchReportPriceItem) => {
    this.searchReportPriceItem = {
      ...this.searchReportPriceItem,
      ...searchReportPriceItem,
    };
    this.getReportPriceItem();
  };

  resetStore = () => {
    this.searchReportPriceItem = {
      ...new SearchObject(),
      isUse: true,
      type: this.currentTab,
      groupIds: [],
      reportGroupIds: [],
      typePriceIds: [],
      minPrice: null,
      maxPrice: null,
    };
    this.pageReportPriceItem = null;
  };
}
